import { api } from "./backend";

export function precargaCombos(filtros) {
  return api.get("ofertaPrecarga/combos", { params: filtros }).then((r) => r.data);
}
